export default "__VITE_ASSET__CJLVj1H6__";